import React, { memo, useContext } from 'react'
import { Context } from '@cgtrader/triangle-ui/dist/src/ssr-index'

// The wrapped component is memoized so a context change only re-renders consumers whose mapped
// props actually changed. Providers like ListingPage build a fresh context object on every
// render, so without this every consumer (three per model card) re-rendered on each filter tap.
const withTriangleUiContext = (mapStateToProps = () => { }) => (Component) => {
  const MemoizedComponent = memo(Component)

  return function ({ ...props }) {
    const context = useContext(Context)

    return (
      <MemoizedComponent {...props} {...mapStateToProps(context, props)} />
    )
  }
}

export default withTriangleUiContext
